<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <v-layout wrap mt-4>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="First Name" outlined v-model="updatedContact.firstName" dense></v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="Last Name" outlined v-model="updatedContact.lastName" dense></v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="Email" outlined v-model="updatedContact.email" dense></v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="Title" outlined v-model="updatedContact.title" dense></v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="Phone #" outlined v-model="updatedContact.phone" dense></v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field
          textarea
          outlined
          dense
          label="Notes"
          auto-grow
          rows="2"
          v-model="updatedContact.notes"
        />
      </v-flex>
    </v-layout>
    <div slot="actions">
      <v-layout>
        <v-btn @click="$emit('save', updatedContact)" color="primary">Save</v-btn>
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import ActionModal from "./ActionModal";
export default {
  name: "ContactModal",
  props: {
    contact: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    ActionModal,
  },
  computed: {
    updatedContact() {
      return this.contact;
    },
    open() {
      return this.isOpen;
    },
  },
  methods: {
    close() {
      this.$emit("update:contactModal", false);
    },
  },
};
</script>
